import { setStep } from "../../redux/payment/slice";
import { PAYMENT_STEPS } from "../../types/PaymentMethodsTypes";

export const noActionHandler = (dispatch, statusCode) => {
  if (statusCode === 200 || statusCode === 201) {
    dispatch(setStep(PAYMENT_STEPS.PENDING_SUCCESS));
  } else {
    dispatch(setStep(PAYMENT_STEPS.FAILED));
  }
};
